var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar"},_vm._l((_vm.widgets),function(widget,index){return _c('SidebarWidget',{key:index,staticClass:"sidebar-widget",attrs:{"widget":widget,"in-sidebar":true}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }